import React, { useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import * as Yup from 'yup';
import i18n from 'i18n-js';
import { usePrevious } from 'hooks';
import Grid from '@material-ui/core/Grid';
import { Formik, Form, Field } from 'formik';

import { BaseModal } from 'components/UI';
import { TextField } from 'components/FormFields';
import { CustomersAction } from 'state/modules/customers';

const AddCreditsModal = ({ id, open, account, handleClick }) => {
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const { errors, fetchedAddNfcCard, fetchingAddNfcCarf } = useSelector((state) => state.customers);
  const prevFetched = usePrevious(fetchedAddNfcCard);

  const formSchema = Yup.object().shape({
    device_id: Yup.string()
      .required(i18n.t('common.required_field'))
      .min(8, i18n.t('common.min_value_8'))
      .max(8, i18n.t('common.max_value_8')),
  });

  const onSubmit = () => {
    formRef.current.submitForm();
  };

  useEffect(() => {
    if (fetchedAddNfcCard && fetchedAddNfcCard !== prevFetched && open) {
      handleClick();
      dispatch(CustomersAction.resetAddNfcCard());
    }
  }, [fetchedAddNfcCard, prevFetched, open, handleClick, dispatch]);

  return (
    <BaseModal
      size="sm"
      open={open}
      hasEnterButton
      hasCancelButton
      onEnter={onSubmit}
      onCancel={handleClick}
      closeButtonType="icon"
      enableCloseButton={false}
      handleClick={handleClick}
      loading={fetchingAddNfcCarf}
      title={i18n.t('users.assign_nfc_card')}
    >
      <Formik
        innerRef={formRef}
        initialValues={{
          device_id: '',
        }}
        onSubmit={(values) => {
          const payload = {
            broker: 'OTKAD',
            meta_data: {
              ...values,
              ad_type: 'CARD',
              user_id: id,
            },
          };

          dispatch(CustomersAction.fetchAddNfcCard(payload));
        }}
        validationSchema={formSchema}
      >
        {({ handleSubmit }) => (
          <Form noValidate onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Field
                  type="text"
                  margin="none"
                  required={false}
                  name="device_id"
                  inputProperties={{}}
                  component={TextField}
                  asyncErrors={errors?.rrd_device}
                  label={i18n.t('users.rrd_device')}
                />
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </BaseModal>
  );
};

AddCreditsModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired,
};

AddCreditsModal.defaultProps = {
  open: false,
  handleClick: () => {},
};

export default AddCreditsModal;
